import React, {useContext, useEffect, useState} from 'react';
import {local} from 'lib/StorageUtil';
import sessionStore from 'client/Session/SessionStore';
import appStore from 'client/AppStore';
import {Button, Icon, Modal, Text} from '@albert-io/atomic';
import makeConstants from 'lib/makeConstants';
import {pluralize} from 'lib/stringUtils';

import {ContentDiscoveryContext} from '../../ContentDiscoveryProvider.react';
import QuestionPreviewSeparated from '../../QuestionPreview/QuestionPreviewSeparated.react';
import AssignmentBuilderIntroModal from './AssignmentBuilderIntroModal/AssignmentBuilderIntroModal.react';
import BetaFeedBackLink from '../BetaFeedBackLink.react';
import SideBarSlider from './FilterGroup/FilterGroup.react';

import './document-content-discovery.scss';

const ContentDiscoverySteps = makeConstants('add', 'review', 'settings');
interface Props {
  step: 'add' | 'review';
}

const DocumentContentDiscovery = ({step}: Props) => {
  const userId = sessionStore.getUserId();
  const HAS_SEEN_BUILDER_INTRO_TOKEN = `${userId}-hasSeenBuilderIntro`;

  const {setDraftId, setCurrentPage, setAutoSave, totalQuestionCount} =
    useContext(ContentDiscoveryContext);
  const [isLoading, setIsLoading] = useState(false);
  const [showIntroModal, setShowIntroModal] = useState(!local.get(HAS_SEEN_BUILDER_INTRO_TOKEN));
  /*

  */

  const {query} = appStore.routerProps.location;
  useEffect(() => {
    const fetchData = async () => {
      if (Object.prototype.hasOwnProperty.call(query, 'draftId')) {
        const draftIdValue = query.draftId;
        setIsLoading(true);
        try {
          setDraftId(draftIdValue);
          setAutoSave(true);
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [query, setDraftId]);

  if (isLoading) {
    return <div>Loading</div>;
  }

  const questionText = `(${totalQuestionCount} ${pluralize(
    'question',
    totalQuestionCount
  )} in your assignment)`;
  return (
    <div className='assignment-body u-display_flex u-flex-direction_row u-bgc_slate-100'>
      {step === ContentDiscoverySteps.add ? (
        <Modal ariaLabel='Add questions' fullscreen className='u-pad_0'>
          {({CloseButtonWrapper}) => (
            <div className='add-questions__view-wrapper--modal'>
              <div className='add-questions__top-bar'>
                <Text
                  size='l'
                  className='u-font-weight_900 u-display_flex u-flex-direction_column u-align-items_flex-start'
                >
                  Add Questions{' '}
                  <Text size='m' className='u-font-weight_normal'>
                    {questionText}
                  </Text>
                </Text>
                <BetaFeedBackLink className='u-mar-l_auto' />
                <CloseButtonWrapper>
                  <Button
                    onClick={() => setCurrentPage('review')}
                    data-test-id='add-questions-list_done-btn'
                  >
                    Done Adding <Icon icon={['far', 'circle-xmark']} className='u-mar-l_1 fa-lg' />
                  </Button>
                </CloseButtonWrapper>
              </div>
              <div className='u-display_flex u-flex-grow_1 u-overflow_hidden u-position_relative'>
                <SideBarSlider />
                <div className='add-questions__results-wrapper--no-gap u-mar-lr_2 u-mar-t_2 u-mar-b_1'>
                  <QuestionPreviewSeparated />
                </div>
              </div>
            </div>
          )}
        </Modal>
      ) : (
        <div className='add-questions__view-wrapper'>
          <div className='add-questions__results-wrapper'>
            <QuestionPreviewSeparated />
          </div>
        </div>
      )}
      {showIntroModal && (
        <AssignmentBuilderIntroModal
          handleClose={() => {
            local.set(HAS_SEEN_BUILDER_INTRO_TOKEN, true);
            setShowIntroModal(false);
          }}
        />
      )}
    </div>
  );
};

export default DocumentContentDiscovery;
